<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>考勤列表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row>
      <el-col :span="12">
        <div class="grid-content bg-purple-light">
          <el-calendar v-model="value" id="calendar" @click="Select">
            <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
            <template slot="dateCell" slot-scope="{ data}">
              <!--自定义内容-->
              <div>
                <div class="calendar-day" style="width:85px; height:55px" @click="Select">{{ data.day.split('-').slice(1).join('-') }} {{ data.isSelected ? '✔️' : ''}}</div>
                <div v-for="(item,index) in calendarData" :key="index">
                  <div v-if="(item.workDate==data.day)">
                    <!-- <el-tooltip class="item" effect="dark" :content="item.things" placement="right"> -->
                      <el-popover
                        placement="top-start"
                        width="240"
                        trigger="hover">
                        <div>工作时长:{{item.wTime}}<br/>上班打卡时间:{{item.onDuty==null?'未打卡':item.onDuty}}<br/>下班打卡时间:{{item.offDuty==null?'未打卡':item.offDuty}}</div>
                        <div slot="reference" :class="item.status =='异常'|| item.status==' 休息日打卡 '?'is_notnormal': 'is-selected' ">{{item.status}}</div>
                      </el-popover>
                    <!-- </el-tooltip> -->
                  </div>
                  <div v-else></div>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
        <div class="bottom_detail">
          <!-- <el-row>
            <div>
              <label style="float:left">工作时长:</label>
              <span style="color:#1989FA;float:left">{{wTime}}</span>
              <label style="float:left">小时</label>
            </div>
          </el-row> -->
          <!-- <el-row>
            <div>
              <label style="float:left">上班打卡时间:</label>
              <span style="color:#1989FA;float:left">{{onDuty}}</span>
            </div>
          </el-row>
          <el-row>
            <div>
              <label style="float:left">下班打卡时间:</label>
              <span style="color:#1989FA;float:left;height:25px">{{offDuty}}</span>
            </div>
          </el-row> -->
        </div>
      </el-col>
      <el-col :span="12">
        <div class="grid-content bg-purple">
          <div id="echartContainer" style="width:800px; height:500px"></div>
        </div>

        <div style="position:absolute; bottom:0;">
          <el-row>
            <el-col :span="12">
              <label style="float:left">迟到早退次数:</label>
              <span style="color:#1989FA;float:left">{{ this.model.LateEarty }}</span>
            </el-col>
            <el-col :span="12">
              <label style="float:left">未打卡次数:</label>
              <span style="color:#1989FA;float:left">{{ this.model.NoPunch }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <label style="float:left">其他扣款:</label>
              <span style="color:#1989FA;float:left">{{ this.model.OtherDeductions }}</span>
            </el-col>
            <el-col :span="12">
              <label style="float:left">补发金额:</label>
              <span style="color:#1989FA;float:left">{{ this.model.Reissuing }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <label style="float:left">更新时间:</label>
              <span style="color:#1989FA;float:left ">{{ this.model.UpdateTime }}</span>
            </el-col>
            <el-col :span="12">
              <label style="float:left">创建时间:</label>
              <span style="color:#1989FA;float:left">{{ this.model.CreateTime }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <label style="float:left">状态:</label>
              <span style="color:#1989FA;float:left">{{ this.model.Status }}</span>
            </el-col>
            <el-col :span="12">
              <label style="float:left">备注:</label>
              <span style="color:#1989FA;float:left; font-size:13px ">{{ this.model.Remark }}</span>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
import { getUrlKey } from "../../until/ZeusApiSDK/Logic/ImageStr";
import {
  GeteAttendanceList,
  GeteAttendanceSummary,
  GetAttendanceDay,
  GetAttendanceDayOnePc,
  GetHomeAttendanceDay
} from "../../until/ZeusApiSDK/Logic/AttendanceListLogic";
import {
  GetSingeleUser,
  GeteUserBaseList,
  GetUserContactList,
  GetUserContractList,
  GetUseEducationList,
  GetUseEmergencyList,
  GetUseFamilyList,
  GetUseQualificationList,
  GetUseWorkHistoryList
} from "../../until/ZeusApiSDK/Logic/StructureLogic";

const echarts = require("echarts");
export default {
  data() {
    return {
      year:"",//年份
      DataName: {}, //考勤汇总
      chModelList: [], //考勤汇总
      chModelList1: [], //考勤汇总
      model: {}, //考勤汇总
      list: [], //每天打卡详情
      onDuty: "", //上班打卡时间
      offDuty: "", //下班打卡时间
      wTime: "", //工作时长
      currentUser: {}, //当前登录用户信息
      userBase: {}, //用户基本信息
      AttendanceList: {}, //考勤数据
      AttendanceSummary: {}, //考勤汇总
      input: "",
      activeName: "first",
      calendarData: [],
      value: new Date(),
      joinValue: "",
      startTime:'',
      endTime:''
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", () => {
        this.joinValue =
          new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
          //新加验证
         if((new Date().getMonth()+1)=="1")
         {
             this.joinValue =
          (new Date().getFullYear()-1) + "-" + (this.value.getMonth() + 1) + "-01";
          this.year=new Date().getFullYear()-1;
         }
         
        else{
          this.year='0';
        }


      
        this.geteAttendance();
       
        var dataSum = {
          Year:this.year,
          Month: this.value.getMonth() + 1,
          CurrentUserCode: this.currentUser.UserCode
        };
        
        GeteAttendanceSummary(dataSum).then(res => {
          if (res.model != null) {
            //基于准备好的dom, 初始化echarts实例
            this.model = res.model;
            this.chModelList = res.chModelList;
            this.chModelList1 = res.chModelList1;
            this.DataName = res.DataName;
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                  //data:[{"value":22,"name":"正常出勤天数"}]
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                  //data:[{"value":22,"name":"实际出勤天数"}]
                }
              ]
            });
          } else {
            this.open();
            this.model = " ";
            this.chModelList = [];
            this.chModelList1 = [];
            this.DataName = " ";
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                  //data:[{"value":22,"name":"正常出勤天数"}]
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                  //data:[{"value":22,"name":"实际出勤天数"}]
                }
              ]
            });
          }
        });
      });
      // 点击 今天
      let todayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      todayBtn.addEventListener("click", () => {
        this.joinValue =
          new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
        this.geteAttendance();
        var dataSum = {
          Year:"0",
          Month: this.value.getMonth() + 1,
          CurrentUserCode: this.currentUser.UserCode
        };
        console.log("杨红宾考勤汇总数据");
        GeteAttendanceSummary(dataSum).then(res => {
          if (res.model != null) {
            //基于准备好的dom, 初始化echarts实例
            this.model = res.model;
            this.chModelList = res.chModelList;
            this.chModelList1 = res.chModelList1;
            this.DataName = res.DataName;
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                  //data:[{"value":22,"name":"正常出勤天数"}]
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                  //data:[{"value":22,"name":"实际出勤天数"}]
                }
              ]
            });
          } else {
            this.open();
            this.model = " ";
            this.chModelList = [];
            this.chModelList1 = [];
            this.DataName = " ";
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                  //data:[{"value":22,"name":"正常出勤天数"}]
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                  //data:[{"value":22,"name":"实际出勤天数"}]
                }
              ]
            });
          }
        });
      });
      // 点击后一个月
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        this.joinValue =
          new Date().getFullYear() + "-" + (this.value.getMonth() + 1) + "-01";
        this.geteAttendance();
        var dataSum = {
           Year:"0",
          Month: this.value.getMonth() + 1,
          CurrentUserCode: this.currentUser.UserCode
        };
        GeteAttendanceSummary(dataSum).then(res => {
          if (res.model != null) {
            //基于准备好的dom, 初始化echarts实例
            this.model = res.model;
            this.chModelList = res.chModelList;
            this.chModelList1 = res.chModelList1;
            this.DataName = res.DataName;
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                  //data:[{"value":22,"name":"实际出勤天数"}]
                }
              ]
            });
          } else {
            this.open();
            this.model = " ";
            this.chModelList = [];
            this.chModelList1 = [];
            this.DataName = " ";
            let myChart = echarts.init(
              document.getElementById("echartContainer")
            );
            myChart.setOption({
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)"
              },
              legend: {
                orient: "vertical",
                x: "left",
                data: this.DataName
              },
              series: [
                {
                  name: "访问来源",
                  type: "pie",
                  selectedMode: "single",
                  radius: [0, "30%"],

                  label: {
                    normal: {
                      position: "inner"
                    }
                  },
                  labelLine: {
                    normal: {
                      show: false
                    }
                  },
                  data: this.chModelList
                },
                {
                  name: "访问来源",
                  type: "pie",
                  radius: ["40%", "55%"],
                  label: {
                    normal: {
                      formatter:
                        "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                      backgroundColor: "#eee",
                      borderColor: "#aaa",
                      borderWidth: 1,
                      borderRadius: 4,
                      rich: {
                        a: {
                          color: "#999",
                          lineHeight: 22,
                          align: "center"
                        },
                        hr: {
                          borderColor: "#aaa",
                          width: "100%",
                          borderWidth: 0.5,
                          height: 0
                        },
                        b: {
                          fontSize: 16,
                          lineHeight: 33
                        },
                        per: {
                          color: "#eee",
                          backgroundColor: "#334455",
                          padding: [2, 4],
                          borderRadius: 2
                        }
                      }
                    }
                  },
                  data: this.chModelList1
                }
              ]
            });
          }
        });
      });
    });
    var data = {
      datetimes: this.value.toDateString(),
      name: this.currentUser.TrueName,
      userCode: this.currentUser.UserCode
    };
    var dataSum = {
       Year:"0",
      Month: this.value.getMonth() + 1, //当前月份
      CurrentUserCode: this.currentUser.UserCode
    };
    GeteAttendanceSummary(dataSum).then(res => {
      if (res.model != null) {
        //基于准备好的dom, 初始化echarts实例
        this.chModelList = res.chModelList;
        this.chModelList1 = res.chModelList1;
        this.DataName = res.DataName;
        this.model = res.model;
        let myChart = echarts.init(document.getElementById("echartContainer"));
        myChart.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            x: "left",
            data: this.DataName
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              selectedMode: "single",
              radius: [0, "30%"],
              label: {
                normal: {
                  position: "inner"
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: this.chModelList
              //data:[{"value":22,"name":"正常出勤天数"}]
            },
            {
              name: "访问来源",
              type: "pie",
              radius: ["40%", "55%"],
              label: {
                normal: {
                  formatter:
                    "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                  backgroundColor: "#eee",
                  borderColor: "#aaa",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    a: {
                      color: "#999",
                      lineHeight: 22,
                      align: "center"
                    },
                    hr: {
                      borderColor: "#aaa",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0
                    },
                    b: {
                      fontSize: 16,
                      lineHeight: 33
                    },
                    per: {
                      color: "#eee",
                      backgroundColor: "#334455",
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              },
              data: this.chModelList1
              //data:[{"value":22,"name":"实际出勤天数"}]
            }
          ]
        });
      } else {
        this.open();
        this.model = " ";
        this.chModelList = [];
        this.chModelList1 = [];
        this.DataName = " ";
        let myChart = echarts.init(document.getElementById("echartContainer"));
        myChart.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: "vertical",
            x: "left",
            data: this.DataName
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              selectedMode: "single",
              radius: [0, "30%"],
              label: {
                normal: {
                  position: "inner"
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              data: this.chModelList
              //data:[{"value":22,"name":"正常出勤天数"}]
            },
            {
              name: "访问来源",
              type: "pie",
              radius: ["40%", "55%"],
              label: {
                normal: {
                  formatter:
                    "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                  backgroundColor: "#eee",
                  borderColor: "#aaa",
                  borderWidth: 1,
                  borderRadius: 4,
                  rich: {
                    a: {
                      color: "#999",
                      lineHeight: 22,
                      align: "center"
                    },
                    hr: {
                      borderColor: "#aaa",
                      width: "100%",
                      borderWidth: 0.5,
                      height: 0
                    },
                    b: {
                      fontSize: 16,
                      lineHeight: 33
                    },
                    per: {
                      color: "#eee",
                      backgroundColor: "#334455",
                      padding: [2, 4],
                      borderRadius: 2
                    }
                  }
                }
              },
              data: this.chModelList1
            }
          ]
        });
      }
    });
  },
  methods: {
    open() {
      this.$alert("没有当前月的汇总数据", "", {
        confirmButtonText: "确定"
      });
    },
    Select(tab, event) {
      this.joinValue = new Date().getFullYear() + "-" + tab.toElement.outerText;
      this.geteAttendance();
      this.getAttendanceDayOnePc(tab.toElement.outerText); //绑定每天的打卡数据
    },
    //获取当前用户
    getCurrentUser: function() {
      var userinfo = window.sessionStorage.getItem("userinfo");
      userinfo = JSON.parse(Decrypt(userinfo));
      this.currentUser = userinfo;
    },
    geteAttendance: async function() {
      if (this.joinValue == "" || this.joinValue == null) {
        this.joinValue = this.value.toDateString();
      }
    
      var data = {
        //datetimes:this.value.toDateString(),
        datetimes: this.joinValue,
        name: this.currentUser.TrueName,
        userCode: this.currentUser.UserCode
      };
      console.log(this.joinValue+"杨红宾时间问题查看");
      
      //   var dataSum={
      //     Month:this.value.getMonth()+1,
      //     CurrentUserCode:this.currentUser.UserCode
      // };
      await GetHomeAttendanceDay(data).then(res => {
        res.list.forEach(item => {
          item.workDate=item.workDate.split(' ')[0];
        });
        this.calendarData = res.list;
        this.list = res.list;
        console.log(this.calendarData);
      });
    },
    //获取某一天的打卡详情
    getAttendanceDayOnePc: function(day) {
      if (this.joinValue == "" || this.joinValue == null) {
        this.joinValue = this.value.toDateString();
      }
      var dataDay = {
        // datetimes: this.value.toDateString(),
        datetimes: this.joinValue,
        name: this.currentUser.TrueName,
        userCode: this.currentUser.UserCode,
        day: day
      };
      GetAttendanceDayOnePc(dataDay).then(res => {
        if (res.listDay.length > 0) {
          this.wTime = res.listDay[0].wTime;
          this.onDuty = res.listDay[0].onDuty;
          this.offDuty = res.listDay[0].offDuty;
        } else {
          this.wTime = " ";
          this.onDuty = " ";
          this.offDuty = " ";
        }
      });
    },
    // //获取当前用户信息
    // getUserInfo: function() {
    //   //构造参数
    //   var predicates = [
    //     {
    //       Field: "UserID",
    //       Value: this.currentUser.UserId,
    //       Oper: "eq",
    //       IsAnd: 1
    //     }
    //   ];
    //   //获取userBase基本信息
    //   // GeteUserBaseList(predicates).then(res => {
    //   //   if (res.length > 0) {
    //   //     this.userBase = res[0];
    //   //   }
    //   // });
    // }
  },
  //页面进入加载事件
  created: function() {
    //获取当前用户
    this.getCurrentUser();
    //获取当前用户信息
    //this.getUserInfo();
    //获取考勤日历
    this.geteAttendance();

  }
};
</script>
<style lang="less" scoped>
.calendar-day {
  text-align: center;
  color: #202535;
  line-height: 30px;
  font-size: 12px;
}
.is-selected {
  color: #1989fa;
}
.is_notnormal {
  color: red;
}
.bottom_detail {
  float: left;
  margin-left: 20px;
}
</style>